import api from './api';

export const chatService = {
    // Ask a question about a listing
    askQuestion: async (listingId, question) => {
        try {
            const response = await api.post(`/api/listings/${listingId}/qa`, {
                question: question
            });
            return response.data;
        } catch (error) {
            console.error('Error asking question:', error);
            throw error;
        }
    },

    // Get chat history for a listing (if we add this endpoint later)
    getChatHistory: async (listingId) => {
        try {
            const response = await api.get(`/api/listings/${listingId}/qa`);
            return response.data;
        } catch (error) {
            console.error('Error getting chat history:', error);
            throw error;
        }
    }
}; 